<template>
  <div class="pa-3 rate-card-page">
    <v-row>
      <v-col cols="12">
        <v-card flat class="rate-card-page__toolbar">
          <div>
            <div class="rate-card-page__eyebrow">Creator directory</div>
            <h1 class="rate-card-page__title">Rate Cards</h1>
            <p class="rate-card-page__subtitle">Review creator pricing, platform details, and media kits in one place.</p>
          </div>
          <div class="rate-card-page__actions">
            <v-btn color="secondary" outlined @click.stop="reload()">
              <v-icon left>mdi-cached</v-icon> Refresh
            </v-btn>
            <v-btn color="secondary" @click="copyLink()">
              <v-icon left>mdi-content-copy</v-icon> Copy form link
            </v-btn>
            <input type="hidden" id="copy-link" :value="rateCardLink">
            <v-btn color="success" elevation="0" text v-if="rateCardCopied">
              <v-icon left>mdi-check</v-icon>Copied
            </v-btn>
            <v-btn color="secondary" outlined @click="$refs.rateCardFileInput.click()" v-if="isAdmin">
              <v-icon left>mdi-home-import-outline</v-icon>Import
            </v-btn>
            <v-btn color="secondary" outlined @click="downloadSampleUpload">
              <v-icon left>mdi-download</v-icon>Template
            </v-btn>
            <v-btn color="secondary" @click="download()" v-if="isAdmin">
              <v-icon left small>mdi-file-excel-outline</v-icon> Export
            </v-btn>
          </div>
        </v-card>
      </v-col>
    </v-row>
    <!-- Rate Card Data Table -->
    <rate-card-data-table :reload="isRefresh" :isDownload="isDownload" />
    <!-- excel import file -->
    <input
      type="file"
      accept=".xlsx"
      id="rateCardFileInput"
      ref="rateCardFileInput"
      style="display: none"
      @change="importFileUpload"
    />
    <!-- import loading -->
    <loading
      :active.sync="importLoading"
      :can-cancel="false"
      :is-full-page="true"
      loader="bars"
      background-color="#000"
      color="secondary"
      width.number="180"
      height.number="180"
    />
  </div>
</template>
<script>
import Loading from 'vue-loading-overlay';
import influencerAPIs from '../influencerAPIs';
import RateCardDataTable from './DataTable';
import config from '@/config';
// import moment from 'moment';
import utils from '@/utils';

export default {
  name: 'Brand Fact Sheet',
  components: {
    RateCardDataTable,
    Loading
  },
  data() {
    return {
      rateCardLink: '',
      rateCardCopied: false,
      importLoading: false,
      importItems: [],
      viewID: null,
      isRefresh: 0,
      isDownload: 0
    }
  },
  computed: {
    currentUserRole: function () {
      return Number(this.$store.state.user.role)
    },
    isAdmin: function() {
      return this.currentUserRole === config.userRoles.SUPER_ADMIN_HIGH || this.currentUserRole === config.userRoles.SUPER_ADMIN_LOW
    }
  },
  methods: {
    copyLink() {
      const protocol = window.location.protocol
      const host = window.location.host
      this.rateCardLink = `${protocol}//${host}${config.RATE_CARD_FORM_URL}`
      let vm = this;
      setTimeout(function() { vm.rateCardCopied = utils.func.copyToClipboard('#copy-link') }, 100)
      setTimeout(function() { vm.rateCardCopied = false }, 1000)
    },
    reload() {
      this.isRefresh += 1
    },
    download() {
      this.isDownload += 1
    },
    async importFileUpload(e) {
      this.importLoading = true
      const uploadedFiles = Object.keys(e.target.files).map(i => e.target.files[i]);
      if (!uploadedFiles || uploadedFiles.length === 0) {
        this.$swal({
          type: 'info',
          text: 'No file uploaded'
        });
        return;
      }
      let uploadResp = await new Promise((resolve, reject) => {
        var fr = new FileReader();
        fr.onload = (e) => {
          const tmp = utils.func.parserToJson(e.target.result);
          resolve(tmp)
        };
        fr.readAsArrayBuffer(e.target.files[0]);
        fr.onerror = reject;
      });
      // let handleItems = []
      if (!uploadResp.length) return
      let importItems = []
      if (uploadResp.length > 1) {
        importItems = uploadResp[1]
      } else {
        importItems = uploadResp[0]
      }
      this.uploadRateCard(importItems)
    },
    uploadRateCard(importItems) { // importItems : array
      if (importItems.length === 0) {
        this.$swal({
          title: 'Warning!',
          icon: 'warning',
          text: 'No Imported Rate Card Found'
        });
        return;
      }
      // let formData = new FormData()
      // formData.append('handles', JSON.stringify(importItems))
      let data = Object.assign({}, {
        importItems
      })
      influencerAPIs
      .importRateCard(data)
      .then(resp => {
        this.importLoading = false
        // if (resp.failedInfluencers !== undefined && resp.failedInfluencers.length > 0) {
        //   this.showFailedImportAlert(resp.failedInfluencers)
        //   return false
        // }
        let success = resp.success
        let fails = resp.failed
        let htmlTxt = `Successfully Imported.`
        if (success) {
          htmlTxt += `<br>Success: ${success}`
        }
        if (Array.isArray(fails) && fails.length > 0) {
          htmlTxt += `<br>Failed Rows at: ${fails.join(', ')}`
        }
        this.$swal({
          title: 'Success',
          icon: 'info',
          html: htmlTxt
        });
        this.reload()
      })
      .catch(err => {
        this.importLoading = false
        console.error(err);
        this.$swal({
          title: 'Warning!',
          icon: 'warning',
          showCancelButton: false,
          html: `Failed to Import Influencers`
        });
      });
      this.$refs.rateCardFileInput.value = null;
    },
    downloadSampleUpload() {
      var link = document.createElement('a');
      // If you don't know the name or want to use
      // the webserver default set name = ''
      link.setAttribute('download', 'sample_bulkupload');
      link.href = '/static/sample/sample_ratecard_template.xlsx';
      document.body.appendChild(link);
      link.click();
      link.remove();
    }
  },
  async mounted() {
  }
}
</script>
<style scoped>
.rate-card-page__toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  margin-bottom: 16px;
  padding: 20px 22px;
  border: 1px solid #e6e8ef;
  border-radius: 12px;
  background: linear-gradient(135deg, #ffffff 0%, #f7f8ff 100%);
}

.rate-card-page__eyebrow {
  color: #6f7280;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: .06em;
  text-transform: uppercase;
}

.rate-card-page__title {
  margin: 3px 0 4px;
  color: #22253a;
  font-size: 24px;
  line-height: 1.2;
}

.rate-card-page__subtitle {
  margin: 0;
  color: #6f7280;
  font-size: 14px;
}

.rate-card-page__actions {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 8px;
}

@media (max-width: 960px) {
  .rate-card-page__toolbar {
    align-items: flex-start;
    flex-direction: column;
  }

  .rate-card-page__actions {
    justify-content: flex-start;
  }
}
</style>



// WEBPACK FOOTER //
// index.vue?4c607922